import { Button, Card, Typography } from "@material-tailwind/react";
import { observer } from "mobx-react-lite";
import React from "react";

import { AddressDTO } from "../../../Common/DTOs/Address/AddressDTO";


type AddressCardProps = {
  address: AddressDTO;
  onEdit: (address: AddressDTO) => void;
  onDelete?: (address: AddressDTO) => void;
  classes?: string;
};

export const AddressCard = observer(({ address, onEdit, onDelete, classes }: AddressCardProps) => {
  return (
    <Card className={
      classes ?? "bg-dark-grey text-white p-4 w-[300px] md:w-[400px] shadow-lg rounded-xl border border-light-grey"}>
      <Typography variant="h6" className="mb-5 pb-2 border-b border-light-grey/30">{address.description}</Typography>
      <Typography className="text-sm">{`${address.firstName} ${address.surname}`}</Typography>
      {(address.companyName || address.companyName !== "null") && <Typography className="text-sm">{address.companyName ?? ""}</Typography>}
      <Typography className="text-sm">{address.address1}</Typography>
      {(address.address2 || address.address4 !== "null") && <Typography className="text-sm">{address.address2 ?? ""}</Typography>}
      <Typography className="text-sm">{`${address.postCode}, ${address.address3}`}</Typography>
      {(address.address4 || address.address4 !== "null") && <Typography className="text-sm">{`${address.address4 ?? ""}`}</Typography>}
      {(address.phoneDay || address.phoneDay !== "null") && <Typography className="text-sm">{`${address.phoneDay ?? ""}`}</Typography>}

      <div className="flex justify-end gap-2 mt-4">
        <Button className="bg-purple" size="sm" onClick={() => onEdit(address)}>Edit</Button>
        {!address.isBillingAddress && (
          <Button color="red" size="sm" onClick={() => onDelete?.(address)}>Delete</Button>
        )}
      </div>
    </Card>
  );
});
